import { cssClass } from '../../../../../style';

export const inLineStyle = cssClass('DataAccelerationSection', 'gridContainer', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
});

export const inLineStyleWithHeaderSpacing = cssClass('DataAccelerationSection', 'gridContainer', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: 10
});

export const inLineStyleWithTopMargin = cssClass('DataAccelerationSection', 'gridContainer', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: 2
});

export const dropdownHeight = cssClass('DataAccelerationSection', 'gridContainer', {
  display: 'block',
  height: 0
});

export const dropdownListStyle = { maxHeight: '200px', overflow: 'auto' };